import React, { useState } from 'react';
import { useUploadFile } from '../../../../../api/fileUpload/fileUpload.hooks';

const ImageBlock = ({ data, onChange }) => {
  const { upload, isLoading } = useUploadFile();
  const [uploading, setUploading] = useState(false);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);
    try {
      const result = await upload(file);
      onChange({ ...data, url: result.url || result });
    } catch (error) {
      console.error('Upload failed:', error);
      alert('Failed to upload image');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="basic-form">
      <div className="mb-3">
        <label className="form-label">Upload Image</label>
        <input
          type="file"
          className="form-control"
          accept="image/*"
          onChange={handleFileChange}
          disabled={uploading}
        />
        {uploading && <small className="text-primary mt-1 d-block"><i className="fa fa-spinner fa-spin me-1"></i>Uploading...</small>}
      </div>
      
      {data.url && (
        <div className="mb-3">
          <label className="form-label">Preview</label>
          <div className="border rounded p-2 text-center" style={{ backgroundColor: '#f8f9fa' }}>
            <img src={data.url} alt={data.alt} className="img-fluid rounded" style={{ maxHeight: '300px' }} />
          </div>
        </div>
      )}

      <div className="mb-3">
        <label className="form-label">Alt Text</label>
        <input
          type="text"
          className="form-control"
          placeholder="Alternative text for accessibility..."
          value={data.alt}
          onChange={(e) => onChange({ ...data, alt: e.target.value })}
        />
        <small className="form-text text-muted">Describe the image for screen readers</small>
      </div>
      
      <div className="mb-3">
        <label className="form-label">Caption (Optional)</label>
        <input
          type="text"
          className="form-control"
          placeholder="Image caption..."
          value={data.caption}
          onChange={(e) => onChange({ ...data, caption: e.target.value })}
        />
      </div>
    </div>
  );
};

export default ImageBlock;
